// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as TagsRouteImport } from './routes/tags'
import { Route as AdminLoginRouteImport } from './routes/admin_.login'
import { Route as SitesSlugRouteImport } from './routes/sites.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const TagsRoute = TagsRouteImport.update({
            id: '/tags',path: '/tags',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin_/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const SitesSlugRoute = SitesSlugRouteImport.update({
            id: '/sites/$slug',path: '/sites/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRoute,TagsRoute: TagsRoute,AdminLoginRoute: AdminLoginRoute,SitesSlugRoute: SitesSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)